import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const GoldPriceContext = createContext();

export const useGoldPrice = () => {
  return useContext(GoldPriceContext);
};

export const GoldPriceProvider = ({ children }) => {
  const [goldPrice, setGoldPrice] = useState(80);
  const [priceOunceUsd, setPriceOunceUsd] = useState(null);
  const [makingFeePerGram, setMakingFeePerGram] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchGoldPrice = async () => {
    try {
      const response = await axios.get("/api/gold-price");
      const data = response.data.data || response.data;
      setGoldPrice(parseFloat(data?.pricePerGram || data?.price || 80));
      setPriceOunceUsd(data?.priceOunceUsd ?? null);
      setMakingFeePerGram(parseFloat(data?.makingFeePerGram || 0));
    } catch (error) {
      console.error("Error fetching gold price:", error);
      setGoldPrice(80);
      setMakingFeePerGram(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGoldPrice();
    const interval = setInterval(fetchGoldPrice, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const updateGoldPrice = (newPrice) => {
    setGoldPrice(newPrice);
  };

  const updateGoldSettings = (data) => {
    if (data?.pricePerGram != null) setGoldPrice(data.pricePerGram);
    if (data?.priceOunceUsd != null) setPriceOunceUsd(data.priceOunceUsd);
    if (data?.makingFeePerGram != null) setMakingFeePerGram(data.makingFeePerGram);
  };

  const calculatePrice = (weight, makingFeePerGramOverride) => {
    const mf = makingFeePerGramOverride ?? makingFeePerGram;
    const goldValue = weight * goldPrice;
    const makingFee = weight * mf;
    const total = goldValue + makingFee;
    return {
      goldValue: parseFloat(goldValue.toFixed(2)),
      makingFee: parseFloat(makingFee.toFixed(2)),
      totalPrice: parseFloat(total.toFixed(2)),
    };
  };

  return (
    <GoldPriceContext.Provider
      value={{
        goldPrice,
        priceOunceUsd,
        makingFeePerGram,
        loading,
        updateGoldPrice,
        updateGoldSettings,
        calculatePrice,
      }}
    >
      {children}
    </GoldPriceContext.Provider>
  );
};
